import {
  OrganisationDetailsData,
  ReportingDetailsData,
} from 'constants/organizationDetails.constants';
import { OrganizationDetails } from 'models/OrganizationDetails/organizationDetails.model';
import { FetchLocationProps } from './LocationDetails';
import { getMonthName } from 'shared/utils/monthName';

const createOrgDataEntry = (
  value: string | number | undefined,
  label: string
) => (value ? [{ value, label }] : []);

export const getOrganisationDetails = (
  organizationDetails: OrganizationDetails
) => {
  const { startMonth } = getMonthName(
    organizationDetails?.company?.reportingMonth ?? 0
  );
  const orgDetailsData = [
    {
      title: OrganisationDetailsData.TITLE,
      orgData: [
        ...createOrgDataEntry(
          organizationDetails?.organization?.size?.name,
          OrganisationDetailsData.ORGANIZATION_SIZE
        ),
        ...createOrgDataEntry(
          organizationDetails?.organization?.companyType?.name,
          OrganisationDetailsData.COMPANY_TYPE
        ),
        ...createOrgDataEntry(
          organizationDetails?.organization?.sector?.name,
          OrganisationDetailsData.SECTOR
        ),
        ...createOrgDataEntry(
          organizationDetails?.company?.organizationalBoundary
            ? organizationDetails.company.organizationalBoundary
            : undefined,
          OrganisationDetailsData.ORGANIZATION_BOUNDARY
        ),
      ],
    },
  ];

  const reportingDetailsData = organizationDetails.organization
    ?.organisationYearWise?.isParent
    ? [
        {
          title: ReportingDetailsData.TITLE,
          orgData: [
            ...createOrgDataEntry(
              startMonth,
              ReportingDetailsData.REPORTING_YEAR
            ),
            ...createOrgDataEntry(
              organizationDetails?.company?.baselineYear,
              ReportingDetailsData.BASELINE_YEAR
            ),
            ...createOrgDataEntry(
              organizationDetails?.company?.recalculationThreshold
                ? `${organizationDetails.company.recalculationThreshold} %`
                : undefined,
              ReportingDetailsData.BASELINE_YEAR_RECALCULATION_THRESHOLD
            ),
          ],
        },
      ]
    : [];
  return [...orgDetailsData, ...reportingDetailsData];
};

export const filterLocationParams = (
  params: FetchLocationProps
): FetchLocationProps => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== ''
    )
  );
};

export const getModifiedValues = (
  values: OrganizationDetails
): OrganizationDetails => {
  const { organization, company } = values;
  const { organisationYearWise, sector, companyType, size } =
    organization ?? {};

  const modifiedFormValues: OrganizationDetails = {
    organization: {
      name: organization?.name,
      organisationYearWise: {
        id: organisationYearWise?.id,
        organizationShare: organisationYearWise?.organizationShare,
      },
      sector: {
        id: sector?.id,
      },
      companyType: {
        id: companyType?.id,
      },
      size: {
        id: size?.id,
      },
    },
    company: {
      organizationalBoundary: company?.organizationalBoundary,
      recalculationThreshold: company?.recalculationThreshold,
    },
  };

  return modifiedFormValues;
};
